export default __webpack_public_path__ + "static/media/logo-card-1920w.7f4da035.avif";